import { CashRegisterModel } from '../CashRegisters/types'
import { Product } from '../Products/types'

export type Notice = {
	id: number
	cashRegister: CashRegisterModel
	customer: Customer
	date: string
  /** Сумма всего заказа без скидки */
	sum: number
  /** Процент скидки на весь заказ */
	discount?: number
  /** Сумма скидки на весь заказ */
  discount_sum?: number
  /** Стоимость всего заказа с учетом скидки */
  total: number
	details: Array<{
		product: Product
    /** Стоимость 1 позиции */
		cost: number
    /** Процент скидки на 1 позицию */
    discount?: number
    /** Сумма скидки на одну позицию */
    discount_sum?: number
		count: number
    /** Стоимость позиций без учета скидки в зависимости от кол-ва позиции */
		sum: number
    /** Стоимость позиций с учетом скидки в зависимости от кол-ва позиции */
		total: number
	}>
	payment?: {
		date: string
		id: string | null
	}
  state: NoticeState
}

export enum NoticeState {
  Active = 'Active',
  Refunded = 'Refunded'
}

export type Customer = {
	id: number
	login: string
	name: string
	language: string
}

export enum PayStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid',
}
